import { render } from "./ScrollableListView.vue?vue&type=template&id=961e3a7c&scoped=true"
import script from "./ScrollableListView.vue?vue&type=script&lang=js"
export * from "./ScrollableListView.vue?vue&type=script&lang=js"

import "./ScrollableListView.vue?vue&type=style&index=0&id=961e3a7c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-961e3a7c"]])

export default __exports__